var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 11.3337L8.66699 10.0003L7.33366 8.66699L8.66699 10.0003H4.66699",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 6.66634V9.99967C14.6663 13.333 13.333 14.6663 9.99967 14.6663H5.99967C2.66634 14.6663 1.33301 13.333 1.33301 9.99967V5.99967C1.33301 2.66634 2.66634 1.33301 5.99967 1.33301H9.33301",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 6.66634H11.9997C9.99967 6.66634 9.33301 5.99967 9.33301 3.99967V1.33301L14.6663 6.66634Z",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitDoc);
export default __webpack_public_path__ + "static/media/submit-doc.684470f7bcfb6823fc1322a8b15a8063.svg";
export { ForwardRef as ReactComponent };